import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, reactive, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/yuntuSales/commonEnum/dataConfig'
import { customerContactAdd, customerContactEdit } from '@/api/yuntuSales/customerCenter'
import { listByParamCodes } from '@/api/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import CosInput from '@/components/Antd/CosInput/index.vue'

const __default__ = {
  name: 'ContactsModal'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  contactRefId: {
    type: String
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PotentialItem['contact']>({})
const props = __props
const emit = __emit
const paramCodeData = reactive<{
  lbu_department_title: []
}>({
  lbu_department_title: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_department_title']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
const success = (type: 'add' | 'edit', res: any) => {
  emit('success', type, res)
}
const toggle = (row: PotentialItem['contact']) => {
  form.value = row ? cloneDeep(row) : {}
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        const res = await customerContactEdit(form.value)
        message.success('编辑成功')
        success('edit', res)
      } else {
        const res = await customerContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        message.success('新增成功')
        success('add', res)
      }
      visible.value = false
    } catch (error) {}
    loading.value = false
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createBlock(_component_CosModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((visible).value = $event)),
    title: form.value.id ? '编辑' : '新增',
    class: "clueMerge",
    width: "870px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: form.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "name",
                    rules: [
            {
              required: true,
              message: '请输入'
            },
            { validator: _unref(concatNameValidate) }
          ],
                    label: "联系人姓名"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                        placeholder: "请输入",
                        maxlength: 50
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "mobile",
                    label: "手机号",
                    rules: [
            {
              validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
            }
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.mobile,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.mobile) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "email",
                    label: "邮箱",
                    rules: [
            {
              validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
            }
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.email,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.email) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "wechat",
                    label: "微信号",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.wechat,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.wechat) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "qq",
                    label: "QQ号",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.qq,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.qq) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "tel",
                    label: "固定电话",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.tel,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.tel) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, { label: "性别" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.sex,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.sex) = $event)),
                        options: _unref(dataConfig).genderEnum,
                        placeholder: "请选择",
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "角色",
                    name: "jobRole",
                    rules: {
            message: '请选择',
            validator: _unref(selectForNumberValidate),
            required: true
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.jobRole,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.jobRole) = $event)),
                        options: _unref(dataConfig).linkRoleTypeEnum,
                        placeholder: "请选择",
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "职务",
                    name: "jobDuty",
                    rules: {
            message: '请选择',
            validator: _unref(selectForNumberValidate),
            required: true
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: form.value.jobDuty,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.jobDuty) = $event)),
                        options: paramCodeData.lbu_department_title
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, { label: "传真号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: form.value.fax,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.fax) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "备注",
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosTextarea, {
                        value: form.value.remark,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.remark) = $event)),
                        maxlength: 2000
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})